const TOPICS = [
  [/porcentaje|% del tiempo/i, "Tiempo por actividad (%)"],
  [/herramientas|flujo/i, "Herramientas y flujo"],
  [/cargos|usuarios finales/i, "Estructura y cargos"],
  [/métricas|indicadores/i, "Métricas y metas"],
  [/departamentos/i, "Alcance y departamentos"],
  [/fuentes|datos/i, "Fuentes de datos"],
  [/empresa|contexto|objetivo|estrateg/i, "Contexto y estrategia"],
];

// Consultant questions are the key moments of the ABC interview.
export const questionTopic = (m) => {
  if (m.role !== "consultant" || !m.content.includes("?")) return null;
  const hit = TOPICS.find(([re]) => re.test(m.content));
  return hit ? hit[1] : "Pregunta ABC";
};
